/** Format raw input into (555) 555-5555 as the user types */
export function formatPhoneInput(val: string): string {
  const digits = val.replace(/\D/g, "").slice(0, 10);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/** Convert display format to E.164 (+15555555555) for storage */
export function phoneToE164(display: string): string {
  const digits = display.replace(/\D/g, "");
  if (digits.length !== 10) return "";
  return `+1${digits}`;
}

/** Convert E.164 (+15555555555) to display format (555) 555-5555 */
export function e164ToDisplay(e164: string | null | undefined): string {
  if (!e164) return "";
  const digits = e164.replace(/\D/g, "").slice(-10);
  return formatPhoneInput(digits);
}

/** Returns true if the display-format string represents a complete 10-digit number */
export function isValidPhone(display: string): boolean {
  return display.replace(/\D/g, "").length === 10;
}
